export default __webpack_public_path__ + "static/media/loginbg.175b126e.png";